import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthToken = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const isValid = useMemo(() => {
    if (!token || token === "Bearer undefined") return false;
    try {
      const payload = JSON.parse(
        atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
      );
      const tokenExpiration = payload.exp * 1000;
      return Date.now() <= tokenExpiration;
    } catch (err) {
      console.error("Invalid token:", err);
      return false;
    }
  }, [token]);

  useEffect(() => {
    if (!isValid && token) {
      alert("Your session has expired. Please log in again.");
      localStorage.removeItem("token");
      navigate("/login");
    }
  }, [isValid, token]);

  return isValid ? token : null;
};

export default useAuthToken;
